import React, { useState } from "react";
import { InputAdornment, IconButton, TextField } from "@material-ui/core/";
import VisibleOff from "src/assets/icons/visibleOff.svg";
import VisibleOn from "src/assets/icons/visibleOn.svg";

const PasswordControl = ({
  error,
  inputRef,
  inputProps,
  label = "Password",
  placeholder = "new password",
  name = "password",
  showPassword: externalShowPassword,
  onTogglePassword,
  VisibilityPassword,
  VisibilityOffPassword,
}: any) => {
  const [internalShowPassword, setInternalShowPassword] = useState(false);
  const showPassword =
    externalShowPassword !== undefined
      ? externalShowPassword
      : internalShowPassword;
  const isError = error ? true : false;

  const handleTogglePassword = () => {
    if (onTogglePassword) {
      onTogglePassword();
    } else {
      setInternalShowPassword((prev: boolean) => !prev);
    }
  };

  const PasswordIcon = showPassword
    ? VisibilityPassword || VisibleOn
    : VisibilityOffPassword || VisibleOff;

  const inputRefValue = inputRef || inputProps?.ref;
  const {
    ref,
    InputProps: inputPropsInputProps,
    InputLabelProps: inputPropsInputLabelProps,
    className,
    ...restInputProps
  } = inputProps || {};

  return (
    <TextField
      variant="outlined"
      fullWidth
      label={label}
      placeholder={placeholder}
      name={name}
      type={showPassword ? "text" : "password"}
      inputRef={inputRefValue || ref}
      className={className}
      {...restInputProps}
      InputProps={{
        ...(inputPropsInputProps || {}),
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              aria-label="toggle password visibility"
              onClick={handleTogglePassword}
            >
              <PasswordIcon />
            </IconButton>
          </InputAdornment>
        ),
      }}
      InputLabelProps={{
        shrink: true,
        ...(inputPropsInputLabelProps || {}),
      }}
      error={isError}
      helperText={isError && error}
    />
  );
};

export default PasswordControl;
